// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const params = {
  project: __t.string(),
  prompt: __t.string(),
  style: __t.string(),
  contextJson: __t.string(),
  quality: __t.string(),
  size: __t.string(),
  sourceBlobPath: __t.string(),
};
export const returnType = __t.string()